import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { IonicModule } from "@ionic/angular";
import { TranslateModule } from "@ngx-translate/core";
import { HeaderModule } from "src/app/_component/header/header.module";
import { SharedDirectivesModule } from "src/app/_directives/shared-directives.module";
import { NotificationConfigurationModule } from "../../_component/notification-configuration/notification-configuration.module";
import { PaginationClientSideModule } from "../../_component/pagination-client-side/pagination-client-side.module";
import { BreadcrumbComponentModule } from "./../../_component/breadcrumb/breadcrumb.module";
import { ReportConfigPageRoutingModule } from "./report-config-routing.module";
import { ReportConfigViewModule } from "./report-config-view/report-config-view.module";
import { ReportConfigPage } from "./report-config.page";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ReportConfigPageRoutingModule,
    TranslateModule,
    ReportConfigViewModule,
    PaginationClientSideModule,
    HeaderModule,
    BreadcrumbComponentModule,
    SharedDirectivesModule,
    NotificationConfigurationModule,
  ],
  declarations: [ReportConfigPage],
})
export class ReportConfigPageModule {}
